import type {
  GetPerformanceFinanciereDashboardViewModel,
  performanceFinanciereDashboardSettings,
} from '@/lib/types'

export default {
  async getInfoCardData(): Promise<GetPerformanceFinanciereDashboardViewModel> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          chiffre_affaire: 2000000,
          frais_pedagogique: {
            value: 20000,
            percentage: 20,
          },
          marge_brute: {
            value: 80000,
            percentage: 80,
          },
          chiffre_affaires_par_employe: 55000,
        })
      }, 500)
    })
  },

  async getSettings(): Promise<performanceFinanciereDashboardSettings> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          'Frais pédagogique': [
            { start_range: 0, end_range: 50, color: 'red' },
            { start_range: 50, end_range: 75, color: 'orange' },
            { start_range: 75, end_range: 100, color: 'green' },
          ],
          'Marge brute': [
            { start_range: 0, end_range: 50, color: 'red' },
            { start_range: 50, end_range: 75, color: 'orange' },
            { start_range: 75, end_range: 100, color: 'green' },
          ],
        })
      }, 500)
    })
  },

  async getPerformancesParAgence(): Promise<
    Array<{
      id: number
      agence_title: string
      marge_brute: number
      frais_pedagogique: number
    }>
  > {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            id: 1,
            agence_title: 'Agence A',
            marge_brute: Math.floor(Math.random() * 100),
            frais_pedagogique: Math.floor(Math.random() * 100),
          },
          {
            id: 2,
            agence_title: 'Agence B',
            marge_brute: Math.floor(Math.random() * 100),
            frais_pedagogique: Math.floor(Math.random() * 100),
          },
          {
            id: 3,
            agence_title: 'Agence C',
            marge_brute: Math.floor(Math.random() * 100),
            frais_pedagogique: Math.floor(Math.random() * 100),
          },
          {
            id: 4,
            agence_title: 'Agence D',
            marge_brute: Math.floor(Math.random() * 100),
            frais_pedagogique: Math.floor(Math.random() * 100),
          },
          {
            id: 5,
            agence_title: 'Agence E',
            marge_brute: Math.floor(Math.random() * 100),
            frais_pedagogique: Math.floor(Math.random() * 100),
          },
        ])
      }, 500)
    })
  },

  async getPerformancesParFormation(): Promise<
    Array<{
      type_formation: string
      marge_brute: number
      frais_pedagogique: number
    }>
  > {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            type_formation: 'Formation métier',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
          {
            type_formation: 'Soft skills',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
          {
            type_formation: 'Réglementaire',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
        ])
      }, 500)
    })
  },

  async getPerformancesParProduit(): Promise<
    Array<{
      famille_produit: string
      marge_brute: number
      frais_pedagogique: number
    }>
  > {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([
          {
            famille_produit: 'Formation présentielle',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
          {
            famille_produit: 'Formation distancielle',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
          {
            famille_produit: 'E-learning',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
          {
            famille_produit: 'Blended learning',
            marge_brute: Math.floor(Math.random() * 100000),
            frais_pedagogique: Math.floor(Math.random() * 50000),
          },
        ])
      }, 500)
    })
  },
}
